import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('createApplicationForm');

    return {
        CREATE: t('create'),
        NEXT_PLAN_THE_FLIGHT: t('nextPlanTheFlight')
    };
};

export default useTranslation;
